import { ProjectTemplateModel } from '@sixense/ds-organisations-models';

export class DsExportTemplateResponseInterface {
  /**
   *
   */
  projectTemplate: ProjectTemplateModel;
}
